<template>
  <div>
    <div v-if="bikeNotFound" class="cell">
      <Callout type="warning" icon="info_outline">{{ bikeNotFound }}</Callout>
    </div>
    <div class="cell">
      <header class="section-header section-header--lg mt-3">
        <h1 qaid="find-bike-registrationDescription" class="heading">{{ bp('registerCustomersBike') }}</h1>
      </header>
    </div>
    <div class="grid-x grid-margin-x">
      <div class="cell large-6">
        <p class="mb-3" qaid="find-bike-registrationDescription">{{ bp('registrationDescription') }}</p>
        <fieldset class="max-w-sm">
          <div class="form-group" :class="errorMsg ? 'has-error' : ''">
            <label for="serial-input" class="form-label">{{ bp('serialNumber') }}</label>
            <input
              id="serial-input"
              v-model="serialNumber"
              type="text"
              name="serial-input"
              class="form-control"
              qaid="find-bike-serialNumber"
              :maxlength="30"
              @keyup.enter="submitSerialNumber"
            />
            <span v-if="errorMsg" class="form-feedback is-invalid" qaid="find-bike-errorMsg" v-html="errorMsg" />
          </div>
        </fieldset>
        <div class="buttons">
          <trek-button primary qaid="find-bike-button" :disabled="!serialNumber" @click="submitSerialNumber">
            <span v-html="bp('findBike')" />
          </trek-button>
        </div>
        <div class="mb-2">
          <a
            class="underline hover:no-underline"
            :href="`${contextPath}/contact-us`"
            qaid="find-bike-contact-us"
            v-html="bp('requestSupport')"
          />
        </div>
      </div>
      <div class="cell large-6">
        <div class="px-2 py-3 bg-gray-05">
          <img qaid="find-bike-serialNumberLocation" :src="serialNumberLocationImage" />
          <p class="mt-2">{{ bp('serialNumberLocation') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TrekButton from '@/components/TrekButton';

export default {
  components: {TrekButton},
  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    errorMsg: {
      type: String,
      default: '',
    },
    bikeNotFound: {
      type: String,
      default: '',
    },
    contextPath: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      serialNumber: '',
      serialNumberLocationImage:
        'https://trek.scene7.com/is/image/TrekBicycleProducts/BikeRegistration_sn_location?$responsive-pjpg$&wid=785&hei=400',
    };
  },

  methods: {
    submitSerialNumber() {
      if (this.serialNumber && this.serialNumber.length > 0) {
        window.location.href = this.contextPath + '/bike-registration/serial/' + this.serialNumber;
      }
    },
  },
};
</script>
